import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Task from './icon-task.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Task {...validProps} />;
}
SvgComponent.iconName = 'task';

/**
 * @deprecated This is a legacy icon
 */
export const TaskIcon = svgIconWrapper(SvgComponent);
